export const LOG_SERVICE_TEST_ID = 'logServiceButton';

export const TEST_ID = 'droneServiceLogTab';
